// src/components/staff-time/StaffCheckIn.jsx
import React, { useState } from 'react';
import StaffPinEntry from './StaffPinEntry';
import StaffStatus from './StaffStatus';

const StaffCheckIn = () => {
  const [currentStaff, setCurrentStaff] = useState(null);

  const handleStaffVerified = (staff) => {
    setCurrentStaff(staff);
  };

  const handleLogout = () => {
    setCurrentStaff(null);
  };

  if (!currentStaff) {
    return <StaffPinEntry onStaffVerified={handleStaffVerified} />;
  }

  return <StaffStatus staff={currentStaff} onLogout={handleLogout} />;
};

export default StaffCheckIn;